import { isDefined } from "@clipboard-health/util-ts";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useGetQuestions } from "./api/useGetQuestions";
import { useGetWorkplaceWorkerShifts } from "./api/useGetWorkplaceWorkerShifts";

interface UseCanLeaveReviewParams {
  workplaceId: string;
  workplaceType?: string;
}

export function useCanLeaveReview({ workplaceId, workplaceType }: UseCanLeaveReviewParams) {
  const { userId: workerId } = useDefinedWorker();

  const { data: shifts = [] } = useGetWorkplaceWorkerShifts({
    workerId,
    workplaceId,
  });

  const { data: questions = { data: [] } } = useGetQuestions(
    {
      workplaceType: workplaceType ?? "",
      workplaceId,
    },
    { enabled: isDefined(workplaceType) }
  );

  return {
    canLeaveReview: shifts.length > 0 && questions.data.length > 0,
  };
}
